import * as React from 'react';

const ProductDetailUnitInfo = ({ amount , valueUnits , perBox , 'data-t': dataT = 'product-detail-unit-info'  })=>/*#__PURE__*/ React.createElement("span", {
        className: "product-detail-unit-info",
        "data-t": dataT
    }, /*#__PURE__*/ React.createElement("span", {
        className: "product-detail-unit-info__amount"
    }, amount, " ", amount > 1 ? valueUnits.plural : valueUnits.singular), /*#__PURE__*/ React.createElement("span", {
        className: "product-detail-unit-info__unit"
    }, " ", perBox, " "))
;

export { ProductDetailUnitInfo };
//# sourceMappingURL=ProductDetailUnitInfo.js.map
